import * as React from 'react';
import { rgba } from 'polished';
import styled, { useTheme } from 'styled-components';

import useMediaQuery from '@/utils/useMediaQuery';

import { type PlanInfoType } from '../../data/plans';
import { Button, CornerCircles, Heading, Text } from '../design-system';

const Wrapper = styled.div`
  position: relative;
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px dashed ${({ theme }) => rgba(theme.highlightColor, 0.2)};

  padding: 30px 20px 20px;
  min-width: 0;

  @media (max-width: ${({ theme }) => theme.mediaQuery.SMALL}) {
    padding: 20px;
  }
`;

const Header = styled(Heading).attrs({ renderAs: 'h3' })`
  margin-bottom: 20px;

  @media (max-width: ${({ theme }) => theme.mediaQuery.SMALL}) {
    margin-bottom: 10px;
  }
`;

const Divider = styled.div`
  height: 1px;
  width: 80px;
  margin-bottom: 20px;
  background-color: ${({ theme }) => theme.borderColor.DEFAULT};
`;

const Description = styled(Text)`
  text-align: center;
  margin-bottom: 20px;
`;

const CTAButton = styled(Button)`
  margin-top: auto;
`;

interface ReadyToGetStartedItemProps {
  name: string;
  plan: PlanInfoType;
}

export const ReadyToGetStartedItem: React.ComponentType<ReadyToGetStartedItemProps> =
  React.memo(({ plan, name }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.mediaQueryString.SMALL);

    return (
      <Wrapper>
        <Header renderAs="h3">{name}</Header>
        {!isMobile && <Divider />}
        <Description>{plan.description}</Description>
        <CTAButton
          fill={true}
          link={plan.ctaLink}
          size="small"
          text={plan.ctaText}
        />
        <CornerCircles />
      </Wrapper>
    );
  });
